// extracted by mini-css-extract-plugin
export default {"Palette":"Palette_Palette__BCGqV"};